import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { TriangleAlert } from 'lucide-react'

const InactiveWarning = ({
  active,
  onClick,
  label = 'Item is inactive',
  className,
}: {
  active?: boolean
  onClick?: () => void
  label?: string
  className?: string
}) => {
  if (active === true || active === undefined || active === null) return null
  else if (active === false)
    return (
      <Tooltip>
        <TooltipTrigger>
          <span
            onClick={onClick}
            className={cn(
              'cursor-pointer flex items-center gap-2 border-none rounded-full p-[4px] bg-red-500/10',
              className
            )}
          >
            <TriangleAlert className='size-[13px] text-red-500' />
          </span>
        </TooltipTrigger>
        <TooltipContent className='z-99999999'>
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    )
}

export default InactiveWarning
